<template>
	<section class="new-event-hotel-policy">
		<h3>{{translation.title}}</h3>

		<p>{{description}}</p>

		<ul>
			<li v-for="(policy, index) in listPolicies" :key="index">{{policy}}</li>
		</ul>

		<label class="new-event-hotel-policy__agreement">
			<input v-model="agreeWithTheTerms" type="checkbox" required>
			<span>{{translation.termsConfirmation}}</span>
		</label>
	</section>
</template>

<script>
import { translate } from '../../assets/translations';
import { describeCancelationPolicy } from '../../cancellation-policy-utils';
import PaymentMethods from '../../enums/PaymentMethods';

export default {
	props: {
		booking: {
			type: Object,
			required: true,
		},
		paymentMethod: {
			type: Object,
			default: null,
		},
	},
	data() {
		return {
			PaymentMethods,
			agreeWithTheTerms: false,
		};
	},
	computed: {
		description() {
			if (this.paymentMethod && this.paymentMethod.id === PaymentMethods.BANK_TICKET.id) {
				return this.translation.bankticketDescription;
			}
			return this.translation.description(this.totalLabel);
		},
		listPolicies() {
			const policies = [this.translation.firstCondition];
			const cancellationPolicy = this.booking.price ? this.booking.price.cancellationPolicy : null;
			if (cancellationPolicy) {
				policies.push(describeCancelationPolicy(cancellationPolicy, this.$store.state.language));
			}
			return policies;
		},
		totalLabel() {
			const price = this.booking.price || {};
			const currency = price.priceCurrency || {};
			return `${currency.symbol || 'R$'} ${price.price || '0,00'}`;
		},
		translation() {
			return translate(this.$store.state.language).cancelConfirmationPolicy;
		},
	},
	watch: {
		agreeWithTheTerms(newValue) {
			this.$emit('is-agreed-politics-terms', newValue);
		},
	},
};
</script>

<style scoped lang="scss">
.new-event-hotel-policy {
	margin-top: 58px;
	padding-top: 54px;
	border-top: 1px solid rgba(90, 90, 90, .6);
	color: #5a5a5a;
}

.new-event-hotel-policy h3 {
	margin: 0 0 48px;
	color: #002c41;
	font-size: 18px;
	font-weight: 700;
	line-height: 21px;
	text-transform: uppercase;
}

.new-event-hotel-policy h3::before {
	content: "";
	display: block;
	width: 23px;
	height: 12px;
	margin: 0 0 27px;
	background: url("data:image/svg+xml,%3Csvg width='23' height='12' viewBox='0 0 23 12' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M2 2L11.5 10L21 2' stroke='%2366ACC6' stroke-width='3'/%3E%3C/svg%3E") center / contain no-repeat;
}

.new-event-hotel-policy p,
.new-event-hotel-policy li {
	margin: 0;
	font-size: 18px;
	font-weight: 400;
	line-height: 40px;
}

.new-event-hotel-policy ul {
	margin: 35px 0 34px;
	padding-left: 30px;
	list-style: disc;
}

.new-event-hotel-policy__agreement {
	display: inline-flex;
	align-items: center;
	gap: 16px;
	margin: 0;
	color: #5da3bd;
	font-size: 18px;
	font-weight: 400;
	line-height: 21px;
	cursor: pointer;
}

.new-event-hotel-policy__agreement input {
	width: 17px;
	height: 17px;
	margin: 0;
	accent-color: #66acc6;
}

@media (max-width: 900px) {
	.new-event-hotel-policy {
		margin-top: 42px;
		padding-top: 36px;
	}

	.new-event-hotel-policy h3 {
		margin-bottom: 28px;
	}

	.new-event-hotel-policy p,
	.new-event-hotel-policy li,
	.new-event-hotel-policy__agreement {
		font-size: 15px;
		line-height: 26px;
	}
}
</style>



// WEBPACK FOOTER //
// src/components/hotel-reservation/CancelConfirmationPolicy.vue